import {Component, Input} from '@angular/core';

@Component({
    selector: 'jhi-spinner',
    templateUrl: './spinner.component.html'
})
export class SpinnerComponent {
    @Input() display: Boolean;

    constructor() {
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/spinner/spinner.component.ts